const OIDC_STORAGE_PREFIX = "oidc.";

export function isOidcStorageKey(key: string): boolean {
  return key.startsWith(OIDC_STORAGE_PREFIX);
}

function removeMatchingKeys(store: Storage, predicate: (key: string) => boolean): void {
  const keys: string[] = [];
  for (let i = 0; i < store.length; i += 1) {
    const key = store.key(i);
    if (key && predicate(key)) {
      keys.push(key);
    }
  }
  keys.forEach((key) => store.removeItem(key));
}

/** Clears non-HttpOnly cookies for the current origin. IdP HttpOnly cookies cannot be removed from JS. */
export function clearClientCookies(): void {
  if (typeof document === "undefined") return;

  const cookies = document.cookie ? document.cookie.split(";") : [];
  const expire = "Thu, 01 Jan 1970 00:00:00 GMT";
  const hostname = window.location.hostname;

  cookies.forEach((cookie) => {
    const name = cookie.split("=")[0]?.trim();
    if (!name) return;
    document.cookie = `${name}=; expires=${expire}; path=/`;
    document.cookie = `${name}=; expires=${expire}; path=/; max-age=0`;
    if (hostname) {
      document.cookie = `${name}=; expires=${expire}; path=/; domain=${hostname}`;
      document.cookie = `${name}=; expires=${expire}; path=/; domain=.${hostname}`;
    }
  });
}

/**
 * Drops OIDC tokens from localStorage, the current tab session, and client cookies.
 * Safe to call even when IdP logout returns 403.
 */
export function clearAuthSession(): void {
  if (typeof window === "undefined") return;

  try {
    removeMatchingKeys(window.localStorage, isOidcStorageKey);
  } catch {
    // ignore quota / private-mode failures
  }

  try {
    window.sessionStorage.clear();
  } catch {
    // ignore
  }

  clearClientCookies();
}
